import PurePlusIcon from './plus.svg';

export default PurePlusIcon;
